<app-card class="flex-basis-100 mb-12">
  <div cardTitle i18n>Informations objet de valeur</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="metadata?.object || originalMetadata?.object"
      >
        <span class="card__label" i18n>Type d'objet</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value': originalMetadata && !originalMetadata.object,
            }"
            >{{ getValuableObjectTypeLabel(metadata.object!) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.object &&
              originalMetadata?.object !== metadata.object
            "
            >{{ getValuableObjectTypeLabel(originalMetadata.object!) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.insuranceSum || originalMetadata?.insuranceSum"
      >
        <span class="card__label" i18n>Somme d'assurance</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.insuranceSum,
            }"
            >{{ metadata.insuranceSum! }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.insuranceSum &&
              originalMetadata?.insuranceSum !== metadata.insuranceSum
            "
            >{{ originalMetadata.insuranceSum! }}</span
          >
        </div>
      </div>
      <div class="card__row" *ngIf="metadata?.documentKey">
        <span class="card__label" i18n>Document justificatif</span>
        <div class="d-flex gap-2 flex-column card__value">
          <app-file-icon
            height="20px"
            width="20px"
            (click)="viewFile(metadata.documentKey)"
          />
        </div>
      </div>
    </div>
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="
          metadata?.objectDescription || originalMetadata?.objectDescription
        "
      >
        <span class="card__label" i18n>Description de l'objet</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.objectDescription,
            }"
            >{{ metadata.objectDescription! }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.objectDescription &&
              originalMetadata?.objectDescription !== metadata.objectDescription
            "
            >{{ originalMetadata.objectDescription! }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.insurancesTypes || originalMetadata?.insurancesTypes"
      >
        <span class="card__label" i18n>Couvertures</span>
        <div class="d-flex gap-2 flex-column strong-text card__value">
          <div>
            <span
              *ngFor="let insurance of metadata?.insurancesTypes"
              [ngClass]="{
                'new-lead-value':
                  originalMetadata &&
                  !originalMetadata?.insurancesTypes?.includes(insurance),
              }"
            >
              {{ getValuableObjectInsuranceTypeLabel(insurance) }}
            </span>
          </div>
          <div>
            <span
              *ngFor="let insurance of originalMetadata?.insurancesTypes"
              [ngClass]="{
                'old-lead-value':
                  !metadata?.insurancesTypes?.includes(insurance),
              }"
            >
              {{ getValuableObjectInsuranceTypeLabel(insurance) }}
            </span>
          </div>
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          originalMetadata?.documentKey &&
          originalMetadata?.documentKey !== metadata.documentKey
        "
      >
        <span class="card__label" i18n>Ancien document justificatif</span>
        <div class="d-flex gap-2 flex-column card__value">
          <app-file-icon
            height="20px"
            width="20px"
            (click)="viewFile(originalMetadata.documentKey)"
          />
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card class="flex-basis-100 mb-12">
  <div cardTitle i18n>Questionnaire</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="
          (metadata?.hasInsurance !== null &&
            metadata?.hasInsurance !== undefined) ||
          (originalMetadata?.hasInsurance !== null &&
            originalMetadata?.hasInsurance !== undefined)
        "
      >
        <span i18n class="card__label"
          >Est-il ou a-t-il été assuré pour les branches proposées ?</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (originalMetadata.hasInsurance === null ||
                  originalMetadata.hasInsurance === undefined),
            }"
            >{{ getBooleanLabel(metadata.hasInsurance) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.hasInsurance &&
              originalMetadata?.hasInsurance !== metadata.hasInsurance
            "
            >{{ getBooleanLabel(originalMetadata.hasInsurance) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.companyInsuranceName ||
          originalMetadata?.companyInsuranceName
        "
      >
        <span class="card__label" i18n>Compagnie d'assurance</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.companyInsuranceName,
            }"
            >{{ metadata.companyInsuranceName }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.companyInsuranceName &&
              originalMetadata?.companyInsuranceName !==
                metadata.companyInsuranceName
            "
            >{{ originalMetadata.companyInsuranceName }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.policeInsuranceNumber ||
          originalMetadata?.policeInsuranceNumber
        "
      >
        <span class="card__label" i18n>N° de police</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.policeInsuranceNumber,
            }"
            >{{ metadata.policeInsuranceNumber }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.policeInsuranceNumber &&
              originalMetadata?.policeInsuranceNumber !==
                metadata.policeInsuranceNumber
            "
            >{{ originalMetadata.policeInsuranceNumber }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata.hasInsuranceRefused !== undefined ||
            metadata.hasInsuranceRefused !== null) &&
          (originalMetadata?.hasInsuranceRefused !== undefined ||
            originalMetadata?.hasInsuranceRefused !== null)
        "
      >
        <span i18n class="card__label"
          >Une proposition d'assurance pour les branches proposées lui a-t-elle
          été refusée ou l'acceptation/la poursuite du contrat était-elle
          conditionnée à des conditions aggravées ?</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (originalMetadata.hasInsuranceRefused === null ||
                  originalMetadata.hasInsuranceRefused === undefined),
            }"
            >{{ getBooleanLabel(metadata.hasInsuranceRefused) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.hasInsuranceRefused &&
              originalMetadata?.hasInsuranceRefused !==
                metadata.hasInsuranceRefused
            "
            >{{ getBooleanLabel(originalMetadata.hasInsuranceRefused) }}</span
          >
        </div>
      </div>
    </div>
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="
          (metadata?.hasSinister !== null &&
            metadata?.hasSinister !== undefined) ||
          (originalMetadata?.hasSinister !== null &&
            originalMetadata?.hasSinister !== undefined)
        "
      >
        <span i18n class="card__label"
          >A-t-il subi des sinistres dans les branches proposées ?</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (originalMetadata.hasSinister === null ||
                  originalMetadata.hasSinister === undefined),
            }"
            >{{ getBooleanLabel(metadata.hasSinister) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.hasSinister &&
              originalMetadata?.hasSinister !== metadata.hasSinister
            "
            >{{ getBooleanLabel(originalMetadata.hasSinister) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.sinisterReason || originalMetadata?.sinisterReason"
      >
        <span class="card__label" i18n>Description du sinistre</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.sinisterReason,
            }"
            >{{ metadata.sinisterReason }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.sinisterReason &&
              originalMetadata?.sinisterReason !== metadata.sinisterReason
            "
            >{{ originalMetadata.sinisterReason }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-pdf-viewer-modal #pdfViewer />
